import actions from './actions'

export default customerFilterReducer

const initialCustomerFilterState = {
  and: [],
}

/**
 *
 * @param {object=} state
 * @param {object} action
 * @param {string} action.type
 * @param {object=} action.filter
 *
 */
function customerFilterReducer(state = initialCustomerFilterState, action) {
  if (action.type === actions.customerFilterTypes.set) {
    const filter = action.filter

    if (filter) {
      return filter
    }

    return initialCustomerFilterState
  }

  if (action.type === actions.customerFilterTypes.reset) {
    return initialCustomerFilterState
  }

  return state
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/reducers/data/customerFilter/index.js